module.exports = __webpack_public_path__ + "img/empty-matter.bc1cfc91.png";